import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useMotionPreference } from "~/providers/motion-preference-provider";

interface MockupFrameProps {
  children: React.ReactNode;
  className?: string;
}

export function MockupFrame({ children, className = "" }: MockupFrameProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { shouldReduceMotion } = useMotionPreference();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Parallax: mockup rises as it scrolls into view
  const y = useTransform(scrollYProgress, [0, 0.5], [60, 0]);
  const opacity = useTransform(scrollYProgress, [0, 0.3], [0, 1]);

  if (shouldReduceMotion) {
    return (
      <div ref={ref} className={`mockup-frame ${className}`} aria-hidden="true">
        <div className="mockup-chrome">
          <span className="mockup-dot" />
          <span className="mockup-dot" />
          <span className="mockup-dot" />
        </div>
        <div className="mockup-body">{children}</div>
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      className={`mockup-frame ${className}`}
      style={{ y, opacity }}
      aria-hidden="true"
    >
      <div className="mockup-chrome">
        <span className="mockup-dot" />
        <span className="mockup-dot" />
        <span className="mockup-dot" />
      </div>
      <div className="mockup-body">{children}</div>
    </motion.div>
  );
}
